import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row, Space } from 'antd';
import { useAppDispatch } from 'store/hooks';
import { setTour } from 'store/tour/slice';
import { useAuthStateContext } from 'providers/Auth';

import {
  AppointmentItem,
  Appointments,
  Statistics,
  Calendar,
  Charts
} from './components';
import { PageWrapper } from 'components/ui';

const Dashboard: FC = () => {
  const [renderCharts, setRenderCharts] = useState(false);
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const { user: doctor } = useAuthStateContext();

  useEffect(() => {
    setRenderCharts(false);
    setTimeout(() => {
      setRenderCharts(true);
    }, 500);
  }, [i18n.language]);

  useEffect(() => {
    setTimeout(() => {
      dispatch(setTour({ key: 'dashboard', value: true }));
    });
  }, [dispatch]);

  return (
    <PageWrapper
      title={`${t('dashboard.welcome')} ${doctor?.first_name} ${
        doctor?.last_name
      }!`}
      description={t('dashboard.have_nice_day')}
      color="white"
    >
      <Row gutter={[32, 32]} wrap>
        <Col xs={24} xl={16}>
          <Space direction="vertical" size={40} style={{ width: '100%' }}>
            <AppointmentItem />
            <Appointments />
            <Statistics />
          </Space>
        </Col>
        <Col xs={24} xl={8}>
          <Calendar />
        </Col>
      </Row>
      {renderCharts && <Charts />}
    </PageWrapper>
  );
};

export default Dashboard;
